module.exports = __webpack_public_path__ + "static/media/b1.7f560683.jpg";